var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientBabyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#004887"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_1627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 29.5C25.0523 29.5 25.5 29.0523 25.5 28.5C25.5 27.9477 25.0523 27.5 24.5 27.5C23.9477 27.5 23.5 27.9477 23.5 28.5C23.5 29.0523 23.9477 29.5 24.5 29.5Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.415 23.5C22.3119 23.793 22.1204 24.0468 21.867 24.2263C21.6135 24.4058 21.3106 24.5022 21 24.5022C20.6894 24.5022 20.3864 24.4058 20.133 24.2263C19.8795 24.0468 19.688 23.793 19.585 23.5",
    stroke: "#FCFCFC",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.585 23.5C26.688 23.793 26.8795 24.0468 27.133 24.2263C27.3864 24.4058 27.6894 24.5022 28 24.5022C28.3106 24.5022 28.6135 24.4058 28.867 24.2263C29.1204 24.0468 29.3119 23.793 29.415 23.5",
    stroke: "#FCFCFC",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 21.5C33.3311 21.5019 33.163 21.5254 33 21.57C32.3901 19.8009 31.2434 18.2661 29.7197 17.1798C28.196 16.0934 26.3714 15.5095 24.5 15.5095C22.6287 15.5095 20.8041 16.0934 19.2804 17.1798C17.7567 18.2661 16.61 19.8009 16 21.57C15.7241 21.4951 15.4352 21.4802 15.153 21.5264C14.8708 21.5726 14.6017 21.6788 14.364 21.8378C14.1263 21.9968 13.9255 22.2049 13.7751 22.4481C13.6247 22.6914 13.5282 22.964 13.4921 23.2477C13.456 23.5314 13.4811 23.8195 13.5659 24.0927C13.6506 24.3658 13.7929 24.6176 13.9832 24.8311C14.1735 25.0445 14.4074 25.2147 14.6691 25.3301C14.9307 25.4455 15.2141 25.5034 15.5 25.5C15.52 25.5 15.538 25.495 15.558 25.494C15.8086 27.69 16.8585 29.7171 18.5076 31.1888C20.1567 32.6605 22.2897 33.4739 24.5 33.4739C26.7104 33.4739 28.8434 32.6605 30.4925 31.1888C32.1416 29.7171 33.1915 27.69 33.442 25.494C33.462 25.494 33.48 25.5 33.5 25.5C34.0305 25.5 34.5392 25.2893 34.9143 24.9142C35.2893 24.5391 35.5 24.0304 35.5 23.5C35.5 22.9695 35.2893 22.4608 34.9143 22.0858C34.5392 21.7107 34.0305 21.5 33.5 21.5Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 19.232C25.2344 19.3854 24.937 19.4756 24.6309 19.4957C24.3248 19.5158 24.0181 19.4652 23.7347 19.3478C23.4512 19.2304 23.1986 19.0494 22.9963 18.8187C22.7941 18.5881 22.6476 18.314 22.5682 18.0176C22.4887 17.7213 22.4786 17.4107 22.5384 17.1098C22.5983 16.8089 22.7266 16.5258 22.9133 16.2824C23.1001 16.0391 23.3403 15.8419 23.6155 15.7062C23.8906 15.5705 24.1933 15.5 24.5001 15.5",
    stroke: "#FCFCFC",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_1627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientBabyIcon);
export default __webpack_public_path__ + "static/media/patient-baby-icon.7d403e84949a1aa7718537e3f9455fc9.svg";
export { ForwardRef as ReactComponent };